import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getMentionMap } from '@atlassian/ai-model-io/utils/mention-map';
import { getRequestOptions } from './request/request-options';
import { startStreaming } from './request/streaming';
/**
 * Vary prompt request triggered - if latest response exists, we are interrogating,
 * and do not want to use the original config item (i.e. may possibly be summarise/transform)
 *
 * If it is a generate with tag, the response will be captured within
 * the latest "latest response, prompt", flow.
 *
 * REVISIT THIS: analytics is based on the config item, however
 * interrogation analytics uses base generate instead to complete;
 */
function getConfigItem(_ref) {
  var context = _ref.context;
  return context.configItem;
}

/**
 * Get mention map for the current document
 * We can no longer use the node attrs to get the mention name
 * So we now need to get all the mentions and create a mapping that can be used by the
 * markdown serializer
 */
function _getMentionMap(_x) {
  return _getMentionMap2.apply(this, arguments);
}
function _getMentionMap2() {
  _getMentionMap2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var context, mentionMap;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          context = _ref2.context;
          mentionMap = {};
          if (!context.getMentionNameDetails) {
            _context2.next = 6;
            break;
          }
          _context2.next = 5;
          return getMentionMap({
            node: context.editorView.state.doc,
            getMentionNameDetails: context.getMentionNameDetails
          });
        case 5:
          mentionMap = _context2.sent;
        case 6:
          return _context2.abrupt("return", mentionMap);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getMentionMap2.apply(this, arguments);
}
function hitCache(_ref3) {
  var context = _ref3.context,
    cacheKey = _ref3.cacheKey;
  var entries = context.responseHistory.entries;
  var lastHistoryItem = entries[entries.length - 1];
  return lastHistoryItem && cacheKey === lastHistoryItem.cacheKey && context.promptTrigger !== 'interrogate';
}

/**
 * This is responsible for processing the network request data and passing data into the
 * AIExperienceMachine over in createAIExperienceMachine().
 */
export function streaming(context) {
  function callbackHandler(_x2) {
    return _callbackHandler.apply(this, arguments);
  }
  function _callbackHandler() {
    _callbackHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(callback) {
      var abortController, userInput, agent, configItem, mentionMap, requestOptions, cacheKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            abortController = new AbortController();
            userInput = context.userInput, agent = context.configItem.agent;
            configItem = getConfigItem({
              context: context
            });
            _context.next = 5;
            return _getMentionMap({
              context: context
            });
          case 5:
            mentionMap = _context.sent;
            requestOptions = getRequestOptions({
              callback: callback,
              context: context,
              configItem: configItem,
              mentionMap: mentionMap
            });
            cacheKey = JSON.stringify({
              userInput: userInput,
              agent: agent,
              requestOptions: requestOptions
            });
            if (!hitCache({
              context: context,
              cacheKey: cacheKey
            })) {
              _context.next = 11;
              break;
            }
            callback({
              type: 'same cache key'
            });
            return _context.abrupt("return");
          case 11:
            _context.next = 13;
            return startStreaming({
              abortController: abortController,
              cacheKey: cacheKey,
              selectionType: context.selectionType,
              product: context.aiProvider.product,
              getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
              channelId: context.channelId,
              callback: callback,
              requestOptions: requestOptions
            });
          case 13:
            return _context.abrupt("return", function () {
              abortController.abort();
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _callbackHandler.apply(this, arguments);
  }
  return callbackHandler;
}